<ada-container
	#AuthoringPropertyTabsWrapper
	id="AuthoringPropertyTabsWrapper"
	[height]="'100%'"
>
	<ada-tabs-container
		tabBodyPadding="0"
		tabHeaderPadding="1.2rem 0rem"
		verticalWidth="12rem"
		[destroyHidden]="true"
		[height]="'100%'"
		[tabGroupStyles]="{ height: '100%' }"
		[tabNames]="tabNames"
		[vertical]="true"
	>
		@let _propertyMap = (serverObject$ | async | adaCloneObject)?.[targetPropertyMap];

		<!-- General properties -->
		@if ('General' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-general-properties
					#GeneralPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.General ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.General"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Risk properties -->
		@if ('Risk' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-risk-properties
					#RiskPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Risk ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.Risk"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Tracking Properties -->
		@if ('Tracking' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-tracking-properties
					#TrackingPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Tracking ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.Tracking"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Rules Properties -->
		@if ('Rules' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-rules-properties
					#RulesPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Rules ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.Rules"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- MediaDetection properties -->
		@if ('Media' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-media-detection-properties
					#MediaDetectionPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Media ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.Media"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Relationships Properties -->
		@if ('Relationships' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-relationships-properties
					#RelationshipsPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Relationships ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.Relationships"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Cve Mapping Properties -->
		@if ('CVE Mapping' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				height="100%"
				overflowY="auto"
			>
				<ada-cve-mapping-properties
					#CveMappingPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.CveMapping ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.CveMapping"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Content properties -->
		@if ('Content' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-content-properties
					#ContentPropertiesInput
					[availableProperties]="availableProperties"
					[cdnUploadOptions]="cdnUploadOptionsInstallation"
					[currentPropertyObject]="_propertyMap?.Content ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.Content"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Content Override ForRepair properties -->
		@if ('Content For Repair' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-content-override-for-repair-properties
					#ContentForRepairPropertiesInput
					[availableProperties]="availableProperties"
					[cdnUploadOptions]="cdnUploadOptionsRepair"
					[currentPropertyObject]="_propertyMap?.ContentForRepair ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.ContentForRepair"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Content For Uninstallation properties -->
		@if ('Content For Uninstallation' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-content-override-for-uninstallation-properties
					#ContentForUninstallPropertiesInput
					[availableProperties]="availableProperties"
					[cdnUploadOptions]="cdnUploadOptionsUninstallation"
					[currentPropertyObject]="_propertyMap?.ContentForUninstallation ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.ContentForUninstallation"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Install properties -->
		@if ('Install' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-install-properties
					#InstallPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Install ?? {}"
					[editorClass]="editorClass"
					[forCustomization]="targetPropertyMap | forCustomization"
					[inheritedPropertyObject]="inheritedPropertyObject?.Install"
					[isDisabled]="isDisabled"
					[isInheritanceDisabled]="isInheritanceDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Repair properties -->
		@if ('Repair' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-repair-properties
					#RepairPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Repair ?? {}"
					[editorClass]="editorClass"
					[forCustomization]="targetPropertyMap | forCustomization"
					[inheritedPropertyObject]="inheritedPropertyObject?.Repair"
					[isDisabled]="isDisabled"
					[isInheritanceDisabled]="isInheritanceDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Uninstall properties -->
		@if ('Uninstall' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-uninstall-properties
					#UninstallPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Uninstall ?? {}"
					[editorClass]="editorClass"
					[forCustomization]="targetPropertyMap | forCustomization"
					[inheritedPropertyObject]="inheritedPropertyObject?.Uninstall"
					[isDisabled]="isDisabled"
					[isInheritanceDisabled]="isInheritanceDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Install Time properties -->
		@if ('Install Time' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				height="100%"
				overflowY="auto"
			>
				<ada-install-time-properties
					#InstallTimePropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.InstallTime ?? {}"
					[editorClass]="editorClass"
					[forCustomization]="targetPropertyMap | forCustomization"
					[inheritedPropertyObject]="inheritedPropertyObject?.InstallTime"
					[installProcesses]="_propertyMap?.Install?.InterferingProcesses ?? []"
					[isDisabled]="isDisabled"
					[isInheritanceDisabled]="isInheritanceDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Real Time properties -->
		@if ('Real Time' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-real-time-properties
					#RealTimePropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Realtime ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.Realtime"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- User Portal properties -->
		@if ('User Portal' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-user-portal-properties
					#UserPortalPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.UserPortal ?? {}"
					[editorClass]="editorClass"
					[forCustomization]="targetPropertyMap | forCustomization"
					[inheritedPropertyObject]="inheritedPropertyObject?.UserPortal"
					[isDisabled]="isDisabled"
					[isInheritanceDisabled]="isInheritanceDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Extension properties -->
		@if ('Extensions' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-extensions-properties
					#ExtensionsPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Extensions ?? {}"
					[editorClass]="editorClass"
					[forCustomization]="targetPropertyMap | forCustomization"
					[inheritedPropertyObject]="inheritedPropertyObject?.Extensions"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Icon properties -->
		@if ('Icon' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-icon-properties
					#IconPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Icon ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.Icon"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Housekeeping properties -->
		@if ('Housekeeping' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-housekeeping-properties
					#HousekeepingPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Housekeeping ?? {}"
					[editorClass]="editorClass"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Blacklist properties -->
		@if ('Blacklist' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-blacklist-properties
					#BlacklistPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Blacklist ?? {}"
					[editorClass]="editorClass"
					[inheritedPropertyObject]="inheritedPropertyObject?.Blacklist"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Object history -->
		@if ('History' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
				[padding]="'1rem'"
			>
				<ada-card
					#HistoryCard
					data-testid="ada-authoring-property-history-card"
					id="HistoryCard"
					[collapseEnabled]="true"
					[verticalSpacing]="'Small'"
				>
					<ada-text
						content="Object History"
						data-container-selector="ada-card-header"
						id="HistoryCardHeader"
					/>
					<ada-container
						data-container-selector="ada-card-body"
						horizontalSpacing="Medium"
						verticalSpacing="Medium"
						[colCount]="4"
						[padding]="defaultCardPadding"
					>
						<ada-metadata-history-object-table
							[colSpan]="4"
							[isDisabled]="isDisabled"
							[object$]="serverObject$"
							(reverted)="metadataObjectReverted($event)"
						/>
					</ada-container>
				</ada-card>
			</ada-container>
		}

		<!-- Custom Properties -->
		@if ('Custom Properties' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-custom-properties
					#CustomPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Custom ?? {}"
					[editorClass]="editorClass"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}

		<!-- Product -->
		@if ('Product' | hasTab: tabNames) {
			<ada-container
				*adaTemplateMarker
				overflowY="auto"
				[height]="'100%'"
			>
				<ada-product-properties
					#ProductPropertiesInput
					[availableProperties]="availableProperties"
					[currentPropertyObject]="_propertyMap?.Product ?? {}"
					[editorClass]="editorClass"
					[forCustomization]="targetPropertyMap | forCustomization"
					[isDisabled]="isDisabled"
					[isInheritanceDisabled]="isInheritanceDisabled"
					[serverObject$]="serverObject$"
					(propertyObjectEmitter)="authoringPropertyChanged($event)"
				/>
			</ada-container>
		}
	</ada-tabs-container>
</ada-container>
